import React from 'react';
import { Forms, SystemText } from '@salesperformanceint/e4shared';

export const searchDebounceMilliseconds = 500;
export const minimumSearchLength = 3;

const Search = ({ runSearch, defaultSearch, competencies, defaultCompetencyIds }) => {
    const [search, setSearch] = React.useState(defaultSearch);
    const [competencyIds, setCompetencyIds] = React.useState(defaultCompetencyIds);
    const debounceTimeout = React.useRef();

    const cancelPendingSearch = () => clearTimeout(debounceTimeout.current);

    // Search as the user types, once they pause. Skip text that has already been searched
    // (including the initial value) and text too short to narrow the course list.
    // competencyIds is a dependency so a pending search is restarted with the current selection.
    React.useEffect(() => {
        if (search === defaultSearch || search.trim().length < minimumSearchLength) return;

        debounceTimeout.current = setTimeout(() => runSearch(search, competencyIds), searchDebounceMilliseconds);
        return cancelPendingSearch;
    }, [search, competencyIds]);

    // With no text and no competency tags the search would return the whole catalogue
    const canSearch = search.trim().length > 0 || competencyIds.length > 0;

    const searchNow = () => {
        if (!canSearch) return;
        cancelPendingSearch();
        runSearch(search, competencyIds);
    };

    return (
        <div className="mb10">
            <div>
                <Forms.Text
                    id="filter-search"
                    label={SystemText('Admin/Forms/FilePicker/Learn2/Search/Label')}
                    help={SystemText('Admin/Forms/FilePicker/Learn2/Search/Help')}
                    placeholder={SystemText('Admin/Forms/FilePicker/Learn2/Search/Placeholder')}
                    value={search}
                    onChange={x => setSearch(x)}
                    onSubmit={searchNow}
                    data-testid="text-search-learn2"
                    icon="fa-search"
                />
                <Forms.Select
                    label={null}
                    data={competencies || []}
                    allowMultiple
                    value={competencyIds}
                    onChange={setCompetencyIds}
                    data-testid="select-search-learn2"
                />
            </div>
            <div className="mb10">
                <button
                    data-testid="button-search-learn2"
                    id="search-button"
                    className="btn btn-primary"
                    disabled={!canSearch}
                    onClick={searchNow}
                >
                    {SystemText('Admin/Forms/FilePicker/Learn2/Button/Search')}
                </button>
            </div>
        </div>
    );
};

export default Search;
